import { MouseEvent, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Box, Button, Card, Typography, useTheme } from '@mui/material';

import { StateFilter } from '@/lib/filter/stakingPoolState';
import { toast } from 'react-toastify';
import SymbolSvg from '@/assets/assetfi/Symbol';
import { addCommas } from '@/lib/util';
import { PoolState, WITHDRAWALLPRINCIPAL } from '@/lib/common/name-space';
import { useState } from 'react';
import { useWeb3 } from '@/hooks/use-web3';
import BigNumber from 'bignumber.js';
import { CreateUnstakinguser, isCompleteModalType } from '@/types';
import CommonModal from '../modal/CommonModal';
import Loading from '@/component/mui/Backdrop';
import { setCurrencyTicker } from '@/component/admin/currency';
import { ResUserPoolListWithUsdtType } from '@/types/staking/read';

const PortfolioCard = ({
  poolId,
  contractAddr,
  title,
  interestRate,
  symbol,
  state,
  usdt,
  address,
}: ResUserPoolListWithUsdtType) => {
  // theme
  const theme = useTheme();

  // router
  const navigate = useNavigate();
  if (!contractAddr) {
    toast.error('Contract address does not exist.');
    navigate('/pools');
  }

  // 삭제됐는데 다시 넣음: 스테이킹 이후 30분이 지난 시점에 ticker와 usdt를 계산하는데
  // 30분 이전에 언스테이킹을 할 경우 ticker와 usdt가 0으로 나옴
  // 추후에 usdt 계산에서 안 맞을 경우가 있음
  if (BigNumber(usdt).lte('0')) {
    return;
  }

  return (
    <>
      <Card
        onClick={(e: MouseEvent<HTMLDivElement>) => {
          e.stopPropagation();
          const target = e.target as HTMLElement;
          if (target.tagName === 'BUTTON' || target.closest('button')) {
            return;
          }
          navigate('/portfolioDetail', {
            state: {
              contractAddr,
              poolId,
            },
          });
        }}
        sx={{
          flex: 1,
          cursor: 'pointer',
          display: { xs: 'flex', md: 'none' },
          flexDirection: 'column',
          gap: '24px',
          padding: '24px',
          borderRadius: '20px',
          border: `0.5px solid ${theme.greyscale.lightgrey1}`,
          boxShadow: '0px 0px 4px 0px #00000026',
        }}
      >
        <Box sx={{ display: 'flex', gap: '10px' }}>
          <SymbolSvg width={24} height={24} />
          <Typography variant="h6" color={theme.greyscale.darkgrey2}>
            {title}
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Your Stake
          </Typography>
          <Typography component={'div'} variant="h4" color={theme.greyscale.darkgrey2}>
            {addCommas(usdt)}{' '}
            <Typography display={'inline'} variant="body2" color={theme.greyscale.darkgrey2}>
              USDT
            </Typography>
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" color={theme.greyscale.grey1}>
            Symbol
          </Typography>
          <Typography component={'div'} variant="h4" color={theme.greyscale.darkgrey2}>
            {symbol}{' '}
            {/* <Typography display={'inline'} variant="h6" color={theme.greyscale.darkgrey2}>
              SYMBOL
            </Typography> */}
          </Typography>
        </Box>

        <Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: `0.5px solid ${theme.greyscale.lightgrey1}`,
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
          >
            <Typography variant="body2" color={theme.greyscale.grey1}>
              APR
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                {interestRate} %
              </Typography>
            </Box>
          </Box>
          {/* <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: `0.5px solid ${theme.greyscale.lightgrey1}`,
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
          >
            <Typography variant="body2" color={theme.greyscale.grey1}>
              Duration
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                123123
              </Typography>
            </Box>
          </Box> */}
          {/* <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: `0.5px solid ${theme.greyscale.lightgrey1}`,
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
          >
            <Typography variant="body2" color={theme.greyscale.grey1}>
              Total Rewards
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
                {totalRewards.toLocaleString()} USD
              </Typography>
            </Box>
          </Box> */}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: `0.5px solid ${theme.greyscale.lightgrey1}`,
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
          >
            <Typography variant="body2" color={theme.greyscale.grey1}>
              Withdraw
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              {/* <Typography variant="subtitle2" color={state === 0 ? theme.background.blue : theme.greyscale.darkgrey2}> */}
              <Typography variant="subtitle2" color={theme.background.blue}>
                {/* <Withdraw state={state} contractAddr={contractAddr} address={address!} /> */}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: `0.5px solid ${theme.greyscale.lightgrey1}`,
              paddingTop: '8px',
            }}
          >
            <Typography variant="body2" color={theme.greyscale.grey1}>
              Pool Status
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              <Typography
                variant="subtitle2"
                color={
                  state === PoolState.POOLSTATE_WAITING ||
                  state === PoolState.POOLSTATE_FUNDRAISING ||
                  state === PoolState.POOLSTATE_OPERATING
                    ? theme.background.blue
                    : theme.greyscale.darkgrey2
                }
              >
                {StateFilter(state)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Card>

      <Card
        onClick={(e: MouseEvent<HTMLDivElement>) => {
          e.stopPropagation();
          const target = e.target as HTMLElement;
          if (target.tagName === 'BUTTON' || target.closest('button')) {
            return;
          }
          navigate('/portfolioDetail', {
            state: {
              contractAddr,
              poolId,
            },
          });
        }}
        // onClick={() => navigate(`/portfolio/${id}`)}
        sx={{
          flex: 1,
          cursor: 'pointer',
          display: { xs: 'none', md: 'flex' },
          justifyContent: 'space-between',
          padding: '12px 20px',
          borderRadius: '10px',
          border: `0.5px solid ${theme.greyscale.lightgrey1}`,
          boxShadow: '0px 0px 4px 0px #00000026',
          background: state === 0 ? '#ffffff' : theme.background.default,
        }}
      >
        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <SymbolSvg width={24} height={24} />
          <Box>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              Pool Name
            </Typography>
            <Typography variant="h6" color={theme.greyscale.darkgrey2}>
              {title}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: '20px' }}>
          <Box>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              Your Stake
            </Typography>
            <Typography component={'div'} variant="subtitle1" color={theme.greyscale.darkgrey2}>
              {addCommas(usdt)}{' '}
              <Typography display={'inline'} variant="body2" color={theme.greyscale.darkgrey2}>
                USDT
              </Typography>
            </Typography>
          </Box>

          <Box>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              Symbol
            </Typography>
            <Typography component={'div'} variant="subtitle1" color={theme.greyscale.darkgrey2}>
              {symbol}{' '}
              {/* <Typography display={'inline'} variant="h6" color={theme.greyscale.darkgrey2}>
                SYMBOL
              </Typography> */}
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              APR
            </Typography>
            <Typography component={'div'} variant="subtitle1" color={theme.greyscale.darkgrey2}>
              {interestRate} %
            </Typography>
          </Box>

          {/* <Box>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              Duration
            </Typography>
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              {duration}
            </Typography>
          </Box> */}

          {/* <Box>
            <Typography variant="body3" color={theme.greyscale.grey1}>
              Total Rewards
            </Typography>
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              {totalRewards.toLocaleString()}{' '}
              <Typography display={'inline'} variant="body3" color={theme.greyscale.darkgrey2}>
                USD
              </Typography>
            </Typography>
          </Box> */}
        </Box>

        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <Box>
            <Typography variant="h6" color={theme.greyscale.darkgrey2}>
              {/* <Withdraw state={state} contractAddr={contractAddr} address={address!} /> */}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body3" color={theme.greyscale.grey1}>
            Pool Status
          </Typography>
          <Typography
            variant="body1"
            color={
              state === PoolState.POOLSTATE_WAITING ||
              state === PoolState.POOLSTATE_FUNDRAISING ||
              state === PoolState.POOLSTATE_OPERATING
                ? theme.background.blue
                : theme.greyscale.darkgrey2
            }
          >
            {StateFilter(state)}
          </Typography>
        </Box>
      </Card>
    </>
  );
};

export default PortfolioCard;
